module.exports = __webpack_public_path__ + "img/svg/position-2.d5a91b17db17e2e9c98bb26c7de97037.svg";